import React from "react";
import { string } from "prop-types";

import "./textfield.m.css";

const TextField = ({ value, type, error, label, inputType, ...props }) => (
  <div styleName="wrapper" className="wrapper-textfield">
    {label && (
      <label styleName="label" className="label">
        {label}
      </label>
    )}
    <input
      type={type}
      value={value}
      styleName={error ? `${inputType}-error ${inputType}` : inputType}
      className="textfield"
      {...props}
    />
    {error && <span styleName="error">{error}</span>}
  </div>
);

TextField.defaultProps = {
  type: "text",
  inputType: "type1"
};

TextField.propTypes = {
  type: string,
  inputType: string,
  value: string,
  error: string,
  label: string
};

export default TextField;
